import React, { FC, ReactNode, useContext } from 'react';

import ABTestContext from '../../context/ab-test-context';

interface AbTestBranchProps {
  branch: string;
  children: ReactNode;
}

const AbTestBranch: FC<AbTestBranchProps> = ({ branch, children }) => {
  const context = useContext(ABTestContext);
  const { branch: testBranch } = context;
  const shouldRender = branch === testBranch;

  return shouldRender ? <div>{children}</div> : null;
};

export default AbTestBranch;
